import React, { useState } from 'react';
import { withLocalize, Translate } from 'react-localize-redux';
import useInitLocalize from './useInitLocalize';
import AuthPageShell, { storeShape } from './components/AuthPageShell';
import AuthLayout from './components/AuthLayout';
import PasswordStrengthMeter from './components/PasswordStrengthMeter';
import useZxcvbn from './useZxcvbn';

function readResetConfirmData() {
    const el = document.getElementById('resetConfirmData');
    const fallback = { validlink: false, csrfToken: '', actionUrl: window.location.pathname, formErrors: {} };
    if (!el) return fallback;
    try {
        return { ...fallback, ...JSON.parse(el.textContent) };
    } catch (e) {
        return fallback;
    }
}

function serverErrorMessages(formErrors) {
    if (!formErrors) return [];
    return ['new_password1', 'new_password2', '__all__']
        .flatMap(field => (formErrors[field] || []).map(entry => ({ field, message: entry.message })));
}

const ResetConfirmApp = withLocalize(function ResetConfirmApp({ initialize, addTranslationForLanguage }) {
    useInitLocalize(initialize, addTranslationForLanguage);
    const [data] = useState(readResetConfirmData);
    const [password, setPassword] = useState('');
    const { failed, score } = useZxcvbn();

    if (!data.validlink) {
        return (
            <AuthLayout heading="STATIC.PAGES.LOGIN.RESET_HEADING">
                <br />
                <div className="text-info text-center"><strong><Translate id="STATIC.PAGES.LOGIN.LINK_EXPIRED" /></strong></div>
            </AuthLayout>
        );
    }

    const currentScore = score(password);
    // Fail open if the meter can't load; the server still enforces strength on submit.
    const disabled = failed ? !password : (!password || currentScore === 0 || currentScore === null);

    const serverErrors = serverErrorMessages(data.formErrors);

    return (
        <AuthLayout heading="STATIC.PAGES.LOGIN.RESET_HEADING">
            <form id="forgot-password-form" method="post" action={data.actionUrl} role="form" className="registration-form">
                <input type="hidden" name="csrfmiddlewaretoken" value={data.csrfToken} />
                <div className="registration-password form-group">
                    <label htmlFor="registration-password"><Translate id="STATIC.PAGES.LOGIN.PASSWORD" /></label>
                    {serverErrors.map(({ field, message }, i) => (
                        <div className="text-danger" key={`${field}-${i}`}>{message}</div>
                    ))}
                    <input
                        id="registration-password"
                        type="password"
                        className="form-control"
                        name="new_password1"
                        placeholder="Select a strong password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                    />
                    <input type="password" className="sr-only form-control" name="new_password2" value={password} readOnly />
                    {failed ? (
                        <div className="text-info">
                            <Translate id="STATIC.PAGES.LOGIN.STRENGTH_CHECK_UNAVAILABLE" />
                        </div>
                    ) : (
                        <PasswordStrengthMeter score={password ? currentScore : null} />
                    )}
                </div>
                <button
                    id="forgot-password-btn"
                    type="submit"
                    className="btn btn-block btn-singular btn-primary-singular"
                    disabled={disabled}
                >
                    <Translate id="STATIC.PAGES.LOGIN.SAVE" />
                </button>
            </form>
        </AuthLayout>
    );
});

export default function ResetConfirmPage({ store }) {
    return (
        <AuthPageShell store={store}>
            <ResetConfirmApp />
        </AuthPageShell>
    );
}

ResetConfirmPage.propTypes = {
    store: storeShape.isRequired,
};
